<template>
  <mime-types-list
    v-if="selectedUser.id"
    :tier="tierType"
    :id="selectedUser.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import MimeTypesList from "@/views/Common/AttachmentFilters/MimeType.vue";

import { TIER } from "@/constants";

export default {
  name: "MimeTypes",
  components: {
    MimeTypesList,
  },
  data() {
    return {
      tierType: TIER.users,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
